import { render, staticRenderFns } from "./bgys-tasks.vue?vue&type=template&id=1034509a"
import script from "./bgys-tasks.vue?vue&type=script&lang=js"
export * from "./bgys-tasks.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports